<template>
  <div class="card-body py-3">
    <h3 class="mb-0 t-500">
      Research interest
      <i class="fa fa-lightbulb-o d-block pull-right t-placeholder"></i>
    </h3>

    <!--  no research interest present and cannot edit -->
    <template v-if="isLoaded">
      <p v-if="researchGroup.research_interests.length <= 0" class="mb-0 mt-1 t-sm t-secondary">
        No research interest shared.
      </p>

      <ul v-else class="list-unstyled mb-0 mt-3 clearfix flex-wrap d-flex">
        <li class="badge badge-pill badge-secondary--white mr-2 mb-2 bd-radius word-overflow"
          v-for="(r, index) in interests" :key="index"
          :title="`${r.name} (${r.count})`">
          <span>{{ r.name | capitalize}}</span> <span class="t-sm t-secondary pl-1">({{ r.count }})</span>
        </li>
        <li v-if="researchGroup.research_interests.length > 10" class="t-sm w-100">
          <a href="#" @click.prevent="isCollapsed = !isCollapsed">{{ isCollapsed ? 'See all' : 'See less' }}</a>
        </li>
      </ul>
    </template>

    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'

export default {
  name: 'researchGroupType',
  components: {
    Spinner
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    researchGroup: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isCollapsed: true
    }
  },
  computed: {
    interests () {
      const interests = this.researchGroup.research_interests
      if (interests.length > 10 && this.isCollapsed) {
        return interests.slice(0, 10)
      }
      return interests
    }
  }
}
</script>
